<modal class="h-modal custom-cashier__modal {{currentScreenName}} {{getSelectedPaymentMethodName()}}" id="custom_cashier_modal" [ngClass]="currentScreenName == iFramePage ? 'pnp-Iframe custom-cashier-iframe' : ''">
  <div class="">
    <div class="cashier-modal__main slideInRight" [ngClass]="isAbortPage ?  'abort-screen' : ''">
      <div class="cashier-modal__header">
        <span class="back-modal-icn" (click)="backButton()" [ngClass]="(currentScreenName == iFramePage || currentScreenName == transactionStatusPage)&& !isAbortPage && cashierTransactionType =='DEPOSIT' ? '' : 'is-invisbile'"><i class="icon-arrow-2"></i></span>
       <!-- Deposit page heading -->
        <h1 *ngIf="cashierTransactionType =='DEPOSIT'">{{'customCashier.depositHeading' | translate}}</h1>
       <!-- Login page heading -->
        <h1 *ngIf="cashierTransactionType =='LOGIN'">{{'customCashier.loginHeading' | translate}}</h1>
        <span class="close-modal-icn" (click)="showAbortPage(true)" [ngClass]="isAbortPage ?  'is-invisbile' : ''"><i class="icon-cancel-1"></i></span>
      </div>
     
      <div class="cashier-modal__body" [ngClass]=" currentScreenName == paymentDetailsPage ? 'modal_body' : ''"  #cashierContainer> 
       
        <!-- page loader -->
        <ng-container *ngIf="isLoading && !isAbortPage">
          <div class="loader custom-cashier-loader"></div>
        </ng-container>
       
        <!-- Brite iframe -->
        <div id="payment-iframe-container" [ngClass]=" currentScreenName == iFramePage && !isAbortPage ? '' : 'hide-container'" >
       </div>
       <!-- Cashier banner -->
       <app-cashier-banner *ngIf="isPlayUser && currentScreenName == paymentDetailsPage && !isLoading && !isAbortPage" [zoneId]="cashierBannerZoneId"></app-cashier-banner>
       
       <!-- Generic error message -->
       <div *ngIf="transactionMessage && !isAbortPage && !isLoading" class="generic-error-container">
        <app-custom-error-message class="error-message--wrapper"  [message]="transactionMessage" (closeClick)="clearMessage()" [isShowCloseMark]="true"></app-custom-error-message>
       </div>

        <!-- payment details  -->
        <div [ngClass]="currentScreenName == paymentDetailsPage && !isLoading && !isAbortPage ? '' : 'hide-container'">
          <app-payment-methods [selectorData]="selectorData"></app-payment-methods>
          <app-custom-amount (selectedAmountEmitter)="updateAmountSelection($event)"></app-custom-amount>
          <app-payment-details></app-payment-details>
          <app-transaction-breakdown></app-transaction-breakdown>
        </div>


        <!-- abort page -->
        <ng-container *ngIf="isAbortPage">
          <app-abort-page (closeDepositFlowButtonCLick)="closeDepositModal()" (continueButtonClick)="showAbortPage(false)"></app-abort-page>
        </ng-container>

          <!-- scroll notification -->
          <div class="scroll-notification" *ngIf="showScrollBar && currentScreenName ==paymentDetailsPage && !isAbortPage" >
            <i class="icon-arrow-2" (click)="scrollBottom()"></i>
          </div>
      </div>

      <!-- Transaction Button -->
      <div class="cashier-modal__footer" *ngIf="currentScreenName == paymentDetailsPage && !isLoading && !isAbortPage">
        <button class="site-btn--xm site-btn__primary cashier-deposit-button" (click)="processCall()" [disabled]="checkIsInValidAmount()" [ngClass]="checkIsInValidAmount() ? 'invalid-amount' : ''" >
          {{'customCashier.depositButtonText' | translate}} </button>
      </div>
    </div>
  </div>
</modal>
